import { keywordTags } from "@/mocks/homeData";

const footerLinks = [
  { label: "滚动短讯", href: "#live" },
  { label: "话题索引", href: "#index" },
  { label: "大图卡片流", href: "#flow" },
  { label: "发酵时间轴", href: "#timeline" },
  { label: "评论区观点", href: "#opinion" },
  { label: "网友评论速览", href: "#comments" },
  { label: "话题合集", href: "#collections" },
];

export default function SiteFooter() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-background-200">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500" />
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                蝌
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">蝌蚪黑料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              蝌蚪黑料舆情围观单页：聚合蝌蚪黑料热议、蝌蚪黑料舆论发酵的当下进展，
              把评论区与网友评论里的不同观点集中摆在一起，方便快速了解争议来龙去脉。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#index" className="cursor-pointer">
                页面模块索引
              </a>
            </h4>
            <div className="mt-4 grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="cursor-pointer whitespace-nowrap rounded-md px-2 py-1.5 font-label text-sm text-foreground-600 transition-colors hover:bg-background-300/60 hover:text-primary-700"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="#flow" className="cursor-pointer">
                相关话题标签
              </a>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {keywordTags.map((tag) => (
                <span
                  key={tag}
                  className="cursor-pointer whitespace-nowrap rounded border border-background-300 bg-background-100 px-2.5 py-1 font-label text-xs text-foreground-600"
                >
                  #{tag}
                </span>
              ))}
            </div>
            <button
              type="button"
              onClick={scrollTop}
              className="mt-5 flex h-9 items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3 font-label text-sm text-background-50 transition-opacity hover:opacity-90"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-up-line text-sm"></i>
              </span>
              回到顶部
            </button>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-background-300 bg-background-100 p-4">
          <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
            <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
              <i className="ri-information-line text-sm"></i>
            </span>
            本站为单页静态信息展示，内容均为公开讨论话题的整理与归纳，不构成对任何个人或机构的定性判断；
            页面内的按钮与评论交互仅作展示，不接入登录、接口或真实提交。请理性围观，以官方与当事人公开信息为准。
          </p>
        </div>

        <div className="mt-6 flex flex-col items-start justify-between gap-2 border-t border-background-300 pt-5 md:flex-row md:items-center">
          <p className="font-label text-xs text-foreground-500">
            © 2026 蝌蚪黑料 · 持续围观，不急着下结论
          </p>
          <p className="font-label text-xs text-foreground-500">
            内容仅作讨论整理，请以权威公开信息为准
          </p>
        </div>
      </div>
    </footer>
  );
}